/**
 * @desc gradProjectData here the data pertaining to the graduation projects will go
 * #######################################################################
 * #######################################################################
 * ########## REMOVE THE DATA IF NOT REQUIRED ############################
 * #######################################################################
 * #######################################################################
 */

export default [
  {
    id: 1,
    title: "Lorem Ipsum",
    icon: null,
    description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
    industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
    1500s, when an unknown printer took a galley of type and scrambled it to make 
    a type specimen book. It has survived not only five centuries, but also the leap
    into electronic typesetting, remaining essentially unchanged. It was popularised 
    in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
    and more recently with desktop publishing software like Aldus PageMaker including 
    versions of Lorem Ipsum.`,
    githubPath: null,
    demoPath: null,
    year: "2018",
    techUsed: "Python, Flask, OpenCV",
  },
  {
    id: 2,
    title: "Lorem Ipsum",
    icon: null,
    description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
    industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
    1500s, when an unknown printer took a galley of type and scrambled it to make 
    a type specimen book. It has survived not only five centuries, but also the leap
    into electronic typesetting, remaining essentially unchanged. It was popularised 
    in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
    and more recently with desktop publishing software like Aldus PageMaker including 
    versions of Lorem Ipsum`,
    githubPath: null,
    demoPath: null,
    year: "2019",
    techUsed: "MERN Stack, Multichain Blockchain, React HighCharts",
  },
]
